import { defineComponent as f, computed as r, openBlock as p, createElementBlock as b, mergeProps as m, renderSlot as g, createTextVNode as x, toDisplayString as h } from "vue";
const v = /* @__PURE__ */ f({
  __name: "BaseChip",
  props: {
    label: {},
    variant: { default: "grey" },
    size: { default: "md" },
    rounded: { default: "rounded-sm" },
    fontWeight: { default: "font-normal" },
    backgroundColor: {},
    textColor: {},
    borderColor: {}
  },
  setup(t) {
    const o = t, l = {
      sm: "text-xs px-2 py-0.5",
      md: "text-sm px-2.5 py-1",
      lg: "text-base px-3 py-1.5"
    }, n = {
      grey: "chip-grey",
      red: "chip-red",
      green: "chip-green",
      blue: "chip-blue",
      yellow: "chip-yellow",
      purple: "chip-purple"
    }, s = {
      "font-normal": "font-normal",
      "font-medium": "font-medium",
      "font-semibold": "font-semibold",
      "font-bold": "font-bold"
    }, d = {
      "rounded-xs": "rounded-[3px]",
      "rounded-sm": "rounded-sm",
      "rounded-md": "rounded-md",
      "rounded-lg": "rounded-lg",
      "rounded-full": "rounded-full"
    }, i = (e) => e.includes("--trade-short-bg") || e.includes("#e8f0fa") ? "var(--trade-short-text)" : e.includes("--trade-cancel-bg") || e.includes("#f9f3ff") ? "var(--trade-cancel-text)" : e.includes("--table-chip-bg") || e.includes("#eaecee") ? "var(--font-color-footer)" : "var(--font-color-primary)", a = r(() => {
      const e = {};
      return o.label && (e["aria-label"] = o.label), e;
    }), u = r(() => {
      const e = [
        // 1. 레이아웃
        "inline-flex items-center justify-center",
        // 2. 전환 효과
        "transition-all duration-150",
        // 3. 크기별 클래스 (패딩 + 타이포그래피)
        l[o.size] || "text-sm px-2.5 py-1",
        // 4. 폰트 굵기
        s[o.fontWeight] || "font-normal",
        // 5. 테두리
        d[o.rounded] || "rounded-sm",
        // 6. 기본 칩 클래스
        "base-chip",
        // 7. 접근성 관련 클래스
        "focus-visible:outline-none",
        "focus-visible:ring-2",
        "focus-visible:ring-offset-2",
        "focus-visible:ring-blue-500"
      ];
      return o.backgroundColor || o.textColor || o.borderColor || e.push(n[o.variant] || "chip-grey"), e.join(" ");
    }), c = r(() => {
      const e = {};
      return o.backgroundColor && (e.backgroundColor = o.backgroundColor), o.textColor ? e.color = o.textColor : o.backgroundColor && (e.color = i(o.backgroundColor)), o.borderColor && (e.borderColor = o.borderColor, e.borderWidth = "1px", e.borderStyle = "solid"), e;
    });
    return (e, C) => (p(), b("span", m({
      class: u.value,
      style: c.value
    }, a.value), [
      g(e.$slots, "default", {}, () => [
        x(h(t.label), 1)
      ])
    ], 16));
  }
});
export {
  v as default
};
